import React from "react";
const IconMadeInKR = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none" {...props}>
    <path
      d="M52 41.0726H4L9.91885 28.156H46.0812L52 41.0726Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path
      d="M43.1214 28.156H12.8779V25.1041H43.1214V28.156Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path
      d="M43.1214 21.9231H12.8779V18.8712H43.1214V21.9231Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M47.162 15.6896C47.162 18.576 43.1207 18.8712 43.1207 18.8712H12.8772C12.8772 18.8712 8.83594 18.576 8.83594 15.6896C12.2367 16.8899 14.8502 14.9272 14.8502 14.9272H41.1477C41.1477 14.9272 43.7612 16.8899 47.162 15.6896Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path
      d="M43.1198 21.9222C43.1198 21.9222 45.8842 23.7279 49.285 22.5276C49.285 25.414 43.1198 25.1038 43.1198 25.1038H27.998"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path
      d="M12.8783 21.9222C12.8783 21.9222 10.1138 23.7279 6.71307 22.5276C6.71307 25.414 12.8783 25.1038 12.8783 25.1038H28"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path
      d="M30.9814 36.3779C30.9814 34.7315 29.6467 33.3967 28.0002 33.3967V33.3967C26.3538 33.3967 25.0191 34.7315 25.0191 36.3779V41.0724H30.9814V36.3779Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconMadeInKR;
